/* ==========================================================================
   Atelier Sauli - PDP v2 : animations communes. Charge une fois par page.
   ========================================================================== */
(function(){
  if (window.__as2Anim) return;
  window.__as2Anim = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn){
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  /* ---------- 1. Apparition au defilement ---------- */
  function reveal(){
    var sel = [
      '.as2 .title-wrap > *',
      '.as2 .list .row',
      '.as2 .acc details',
      '.as2 .jr-in > *',
      '.as2 .pq > *',
      '.as2 .pqrow',
      '.as2 .stp .tl4row',
      '.as2 .pv > *',
      '.as2 .ucard',
      '.as2 .fcard',
      '.as2 .rcard',
      '.as2 .ccard',
      '.as2 .fqlist details'
    ].join(',');
    var els = document.querySelectorAll(sel);
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function(e){ e.classList.add('as2-in'); });
      return;
    }
    Array.prototype.forEach.call(els, function(e){ e.classList.add('as2-rv'); });
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (!en.isIntersecting) return;
        var el = en.target;
        var idx = Array.prototype.indexOf.call(el.parentNode.children, el);
        el.style.transitionDelay = Math.min(idx, 6) * 90 + 'ms';
        el.classList.add('as2-in');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    Array.prototype.forEach.call(els, function(e){ io.observe(e); });
  }

  /* ---------- 2. Compteur anime ---------- */
  function animateCount(el){
    var target = parseInt(el.getAttribute('data-to'), 10);
    if (!target || target < 2) return;
    var dur = parseInt(el.getAttribute('data-dur'), 10) || 1600;
    function fmt(n){ return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' '); }
    if (reduce) { el.textContent = fmt(target); return; }
    var start = null;
    function step(ts){
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(Math.round(target * eased));
      if (p < 1) requestAnimationFrame(step);
    }
    el.textContent = '0';
    requestAnimationFrame(step);
  }

  function counters(){
    var els = document.querySelectorAll('.as2 [data-to]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, animateCount);
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        animateCount(en.target);
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -5% 0px' });
    Array.prototype.forEach.call(els, function(e){ io.observe(e); });
  }

  /* ---------- 3. Navigation des carrousels ---------- */
  function carousels(){
    var rows = document.querySelectorAll('.as2 .carou, .as2 .dcarou, .as2 .ugc, .as2 .clrow');
    Array.prototype.forEach.call(rows, function(row){
      if (row.dataset.as2Nav) return;
      if (row.scrollWidth <= row.clientWidth + 8) return;
      row.dataset.as2Nav = '1';

      var nav = document.createElement('div');
      nav.className = 'as2-cnav';
      nav.innerHTML =
        '<span class="as2-prog"><i></i></span>' +
        '<span class="as2-arrows">' +
          '<button type="button" aria-label="Precedent">&#8249;</button>' +
          '<button type="button" aria-label="Suivant">&#8250;</button>' +
        '</span>';
      row.parentNode.insertBefore(nav, row.nextSibling);

      var fill = nav.querySelector('.as2-prog i');
      var btns = nav.querySelectorAll('button');
      var prev = btns[0], next = btns[1];

      function stepSize(){
        var first = row.firstElementChild;
        if (!first) return row.clientWidth * 0.8;
        var cs = getComputedStyle(row);
        var gap = parseFloat(cs.columnGap || cs.gap || 12) || 12;
        return first.getBoundingClientRect().width + gap;
      }
      function sync(){
        var max = row.scrollWidth - row.clientWidth;
        var p = max > 0 ? row.scrollLeft / max : 0;
        var visible = Math.max(row.clientWidth / row.scrollWidth, 0.12);
        fill.style.width = (visible * 100) + '%';
        fill.style.transform = 'translateX(' + (p * (100 / visible - 100)) + '%)';
        prev.disabled = row.scrollLeft < 4;
        next.disabled = row.scrollLeft > max - 4;
      }
      prev.addEventListener('click', function(){ row.scrollBy({ left: -stepSize(), behavior: reduce ? 'auto' : 'smooth' }); });
      next.addEventListener('click', function(){ row.scrollBy({ left: stepSize(), behavior: reduce ? 'auto' : 'smooth' }); });
      row.addEventListener('scroll', function(){ window.requestAnimationFrame(sync); }, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  /* ---------- 4. Fondu de la galerie ---------- */
  function gallery(){
    var imgs = document.querySelectorAll('.as2 .gal-main img');
    Array.prototype.forEach.call(imgs, function(img){
      if (img.dataset.as2Fade) return;
      img.dataset.as2Fade = '1';
      img.addEventListener('load', function(){
        if (reduce) return;
        img.classList.remove('as2-fade');
        void img.offsetWidth;
        img.classList.add('as2-fade');
      });
    });
  }

  function boot(){ reveal(); counters(); carousels(); gallery(); }
  ready(boot);
  var as2Reflow;
  window.addEventListener('resize', function(){
    window.clearTimeout(as2Reflow);
    as2Reflow = window.setTimeout(carousels, 150);
  });
  document.addEventListener('shopify:section:load', function(){
    window.setTimeout(function(){ counters(); carousels(); gallery(); }, 60);
  });
})();
